// eslint-disable-next-line monorepo/no-internal-import
import {useIsBasketFlyoutClosing} from '@aboutyou/logic-components/src/backend-services/Basket/hooks/useIsBasketFlyoutClosing';
import {useForceUpdate} from '@aboutyou/utils';
import {useEffect, useRef} from 'react';

export const useForceUpdateOnBasketFlyoutClose = () => {
  const renderKey = useRef(0);
  const forceUpdate = useForceUpdate();
  const isBasketFlyoutClosing = useIsBasketFlyoutClosing();

  useEffect(() => {
    if (isBasketFlyoutClosing) {
      renderKey.current += 1;
      forceUpdate();
    }
  }, [forceUpdate, isBasketFlyoutClosing]);

  return renderKey.current;
};
